<template>
    <v-app>
        <v-content class="container mx-auto">
            <curriculum-search />
        </v-content>
    </v-app>
</template>

<script>
import CurriculumSearch from "./views/CurriculumSearch";

export default {
    components: {
        CurriculumSearch
    },

    data() {
        return {
            currentUrl: ""
        };
    },
    created: function() {
        this.currentUrl = window.location.pathname;
        // console.log(this.currentUrl);
    }
};
</script>
